import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';
export function StatsTable() {
  const stats = [{
    metric: 'Organic Traffic',
    before: '12,400/mo',
    after: '54,600/mo',
    change: '+340%',
    positive: true
  }, {
    metric: 'Player Signups',
    before: '180/mo',
    after: '1,240/mo',
    change: '+589%',
    positive: true
  }, {
    metric: 'Affiliate Revenue',
    before: '€18,500/mo',
    after: '€94,200/mo',
    change: '+409%',
    positive: true
  }, {
    metric: 'First Deposits',
    before: '45/mo',
    after: '312/mo',
    change: '+593%',
    positive: true
  }, {
    metric: 'Cost Per Acquisition',
    before: '€142',
    after: '€38',
    change: '-73%',
    positive: true
  }, {
    metric: 'Domain Authority',
    before: '24',
    after: '61',
    change: '+154%',
    positive: true
  }];
  return <section className="py-20 bg-[#0a1a0f]" data-id="element-148">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-150">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-151">
            Before vs. After{' '}
            <span className="text-[#00ff88]" data-id="element-152">Steelserieshub</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-153">
            Real performance metrics from our client partnerships
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-[#0d2818] border border-[#00ff88]/20 rounded-lg overflow-hidden" data-id="element-154">
          <div className="overflow-x-auto" data-id="element-155">
            <table className="w-full" data-id="element-156">
              <thead className="bg-[#00ff88]/10 border-b border-[#00ff88]/20" data-id="element-157">
                <tr data-id="element-158">
                  <th className="px-6 py-4 text-left text-sm font-bold text-[#00ff88]" data-id="element-159">
                    Metric
                  </th>
                  <th className="px-6 py-4 text-right text-sm font-bold text-[#00ff88] font-mono" data-id="element-160">
                    Before
                  </th>
                  <th className="px-6 py-4 text-right text-sm font-bold text-[#00ff88] font-mono" data-id="element-161">
                    After
                  </th>
                  <th className="px-6 py-4 text-right text-sm font-bold text-[#00ff88] font-mono" data-id="element-162">
                    Change
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-163">
                {stats.map((stat, index) => <tr key={index} className={`${index % 2 === 0 ? 'bg-[#0a1a0f]/50' : 'bg-[#0d2818]'} hover:bg-[#00ff88]/5 transition-colors`} data-id="element-164">
                    <td className="px-6 py-4 text-sm font-medium" data-id="element-165">
                      {stat.metric}
                    </td>
                    <td className="px-6 py-4 text-sm text-right font-mono text-gray-400" data-id="element-166">
                      {stat.before}
                    </td>
                    <td className="px-6 py-4 text-sm text-right font-mono text-white font-semibold" data-id="element-167">
                      {stat.after}
                    </td>
                    <td className="px-6 py-4 text-sm text-right font-mono" data-id="element-168">
                      <span className="inline-flex items-center space-x-1 text-[#00ff88] font-bold" data-id="element-169">
                        <TrendingUp size={16} data-id="element-170" />
                        <span data-id="element-171">{stat.change}</span>
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}